import { ICreators } from '@/store/types';
import { PayloadAction } from '@reduxjs/toolkit';
import { createSliceSteamup } from '../common';

export interface IAdvisor {
  uuid: string;
  permission: string;
  belong: string;
  actualName: string;
  profileAvatarURL: string;
  profileBackgroundUrl: string;
}
interface ICreatorsState {
  loading: boolean;
  list: ICreators[];
  rankList: ICreators[];
  advisorList: IAdvisor[];
  filter: {
    q: string,
    order?: 'default' | 'like' | 'contents' | 'follower',
  }
}

const creatorsSlice = createSliceSteamup(
  'contents',
  {
    loading: true,
    list: [],
    rankList: [],
    advisorList: [],
    filter: {
      q: '',
      order: undefined,
    },
  } as ICreatorsState,
  {
    setListInit(state, { payload }: PayloadAction<(typeof state.list)>) {
      state.list = payload;
    },
    setTop10ListInit(state, { payload }: PayloadAction<(typeof state.rankList)>) {
      state.rankList = payload;
    },
    // advisor 추가하기
    setAdvisorList(state, { payload }: PayloadAction<(typeof state.advisorList)>) {
      state.advisorList = payload;
    },
    setOrder(state, { payload }: PayloadAction<(typeof state.filter.order)>) {
      state.filter.order = payload;
    },
    setKeyword(state, { payload }: PayloadAction<(typeof state.filter.q)>) {
      state.filter.q = payload;
    },
    setRemoveKeyword(state) {
      state.filter.q = '';
    },
    setReset(state) {
      state.filter.q = '';
    },
  },
);

export default creatorsSlice;
